module.exports = __webpack_public_path__ + "img/IT0000643846212.62c7baf0.png";